import { axios } from '@/utils/request'

const applyForApi = {
  applyForIndex: '/api/v1/pendingAudit/applyFor/index',
  getPendingAuditApplyForById: '/api/v1/pendingAudit/applyFor/getById',
  submitAuditApplyFor: '/api/v1/pendingAudit/applyFor/submitAuditApplyFor'
}

/**
 * 获取待审核列表
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const QueryApplyForIndex = (data) => axios.get(applyForApi.applyForIndex, { params: { ...data } })

/**
 * 根据id获取待审核详情
 * @param id 待审核详情ID
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const GetPendingAuditApplyForById = (id) => axios.get(applyForApi.getPendingAuditApplyForById, { params: { id } })

/**
 * 提交审核
 * @param data 审核内容
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const SubmitAuditApplyFor = (data) => axios.post(applyForApi.submitAuditApplyFor, data)


